import IButton from './Button';
import IRadio from './Radio';
import IList from './List';


export let Button =  IButton;
export let Radio = IRadio;
export let List = IList;
